import React from 'react';
import { useLang, translations } from '../i18n';

const LangToggle: React.FC<{ style?: React.CSSProperties }> = ({ style }) => {
  const { lang, setLang } = useLang();
  const t = translations[lang];
  return (
    <button
      onClick={() => setLang(lang === 'fr' ? 'en' : 'fr')}
      style={{ fontSize: '1.5rem', background: 'none', border: 'none', cursor: 'pointer', ...style }}
      title={lang === 'fr' ? 'Passer en anglais' : 'Switch to French'}
      aria-label={lang === 'fr' ? 'Passer en anglais' : 'Switch to French'}
    >
      {t.flag}
    </button>
  );
};

export default LangToggle;
